"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
var _nanoid = require("./nanoid");
var _default = () => {
  const [id, setId] = (0, _react.useState)('');
  const generated = (0, _react.useRef)();
  // This effect ensures that the ID is generated on mount which
  // happens after hydration, preventing hydration mismatches
  // between server and client.
  (0, _react.useEffect)(() => {
    if (!generated.current) {
      generated.current = (0, _nanoid.generate)();
      setId(generated.current);
    }
  }, []);
  return id;
};
exports.default = _default;